import { hasPermission } from "../../../../../app/auth.js";
import { currentTable } from "../../../../../app/viewManager.js";
import { getSelectedExportRowCount } from "../../../app-table/utils/exportTable.js";

const applicationItemFields = [
    { key: "id", displayKey: "name", render: "dropdown", editable: "once", class: "appManagerDropdown dialogInput" },
    { key: "url", render: "text", editable: "always", placeholder: "URL (z. B. https://...)", class: "appManagerUrlInput dialogInput" },
];
const serviceItemFields = [
    { key: "id", displayKey: "name", render: "dropdown", editable: "once", class: "serviceManagerDropdown dialogInput" },
];

const applicationItemManagerRow = (handler) => ({
    pattern: "itemManager",
    listLabel: "Zugewiesen",
    addLabel: "Applikation hinzufügen",
    emptyText: "Keine Applikationen zugewiesen",
    fields: applicationItemFields,
    buttons: [{ type: "remove" }],
    getFieldOptions: handler.getFieldOptions,
    onConfirm: handler.onConfirm,
    onRemove: handler.onRemove,
    onAddToggle: handler.onAddToggle,
    onMount: handler.onMount,
});
const serviceItemManagerRow = (handler, { includeConfigButton = false } = {}) => ({
    pattern: "itemManager",
    listLabel: "Zugewiesen",
    addLabel: "Service hinzufügen",
    emptyText: "Keine Services zugewiesen",
    fields: serviceItemFields,
    buttons: [
        { type: "toggle", field: "isTranslationActive", icon: "fa-solid fa-language", class: "translationToggleBtn", title: "Übersetzung aktiv", onClick: handler.onToggleTranslation },
        ...(includeConfigButton ? [{
            type: "action", icon: "fa-solid fa-gear", class: "serviceConfigBtn",
            title: item => (item.hasConfiguration || item.configuration) ? "Konfiguration bearbeiten" : "Konfiguration hinzufügen", onClick: handler.onServiceConfig,
        }] : []),
        { type: "remove" },
    ],
    getFieldOptions: handler.getFieldOptions,
    onConfirm: handler.onConfirm,
    onRemove: handler.onRemove,
    onAddToggle: handler.onAddToggle,
    onMount: handler.onMount,
});

const timeLogRows = (buttonText, handlers, leadingRows = []) => [
    ...leadingRows,
    { pattern: "grid", columns: "220px 220px", fields: [
        { label: "Start", id: "inputTimeLogStart", type: "timepicker", attributes: { "data-field": "start" }, placeholder: "Start", required: true },
        { label: "Ende",  id: "inputTimeLogEnd",   type: "timepicker", attributes: { "data-field": "end" },   placeholder: "Ende", onceOptional: true },
    ]},
    { pattern: "divider", size: "lg" },
    { type: "div", children: [
        { type: "div", class: "appManager", style: { width: "452px", minWidth: "452px", padding: "0 12px 20px" }, children: [
            { type: "p", class: "appManagerLabel", text: "Pausen" },
            { type: "div", class: "appManagerList", id: "breakSegmentsList" },
            { type: "button", id: "breakSegmentsAddBtn", class: "appManagerAddToggleBtn", attributes: { type: "button" }, children: [
                { type: "i", class: "fa-solid fa-plus" }, { type: "span", text: "Pause hinzufügen" }
            ]},
        ]}
    ]},
    createSaveFooter(buttonText, handlers.onSave)
];
const entryRows = (buttonText, handlers, isTask = false) => [
    { pattern: "grid", columns: "220px 220px 220px", background: true, fields: [
        { label: "Kunde",       id: "dropdownCustomer",     required: true, attributes: { "data-field": "customerId" } },
        { label: "Applikation", id: "dropdownApplication",  required: true, attributes: { "data-field": "applicationId" } },
        { label: "Projekt",     id: "dropdownProject",      required: true, attributes: { "data-field": "projectId" } }
    ]},
    { pattern: "divider", size: "lg"},
    { pattern: "grid", columns: "220px 460px", fields: [
        { label: "Aktivität",    id: "dropdownActivity",   required: true, attributes: { "data-field": "activityId" } },
        { label: "Beschreibung", id: "inputDescription",   attributes: { "data-field": "description" }, type: "textarea", class: "dialogTextarea dialogInput" }
    ]},
    { pattern: "divider", size: "lg" },
    { pattern: "grid", columns: "220px 220px 220px", fields: [
        { label: "Rechnungsträger", id: "dropdownBillingVia", attributes: { "data-field": "payerId" } },
        { label: "Datum",           id: "inputDate",          required: true,     type: "datepicker", attributes: { "data-field": "date", ...(isTask ? { "disabled": "" } : {})} },
        { label: "Stunden (HH:MM)", id: "inputHoursWorked",   onceOptional: true, type: "timepicker", attributes: { 
                "data-field": "workedHours", "max-time": "10:00", "strict-range": "", ...(isTask ? { "disabled": "" } : {})
            } 
        }
    ]},
    createSaveFooter(buttonText, handlers.onSave)
];
const customerRows = (buttonText, handlers, includeInitialLists = false) => [
    { pattern: "grid", columns: "450px", fields: [
        { label: "Name", id: "inputCustomerName", type: "text", attributes: { "data-field": "name" }, required: true, },
    ]},
    { pattern: "grid", columns: "220px 220px", fields: [
        { label: "Kurzname",  id: "inputCustomerShortName",  type: "text", attributes: { "data-field": "shortName" } },
        { label: "Sprache",   id: "inputCustomerLanguage",   onMount: handlers.initLanguageDropdown },
    ]},
    ...(includeInitialLists ? [
        { pattern: "divider", size: "lg" },
        { pattern: "grid", columns: "450px", fields: [
            { label: "Dashboard Module", id: "inputCustomerDashboardModules", multiple: true, onMount: handlers.initDashboardModulesDropdown },
            { label: "Erlaubte Sprachen", id: "inputCustomerPermittedLanguages", multiple: true, onMount: handlers.initPermittedLanguagesDropdown },
        ]},
    ] : []),
    createSaveFooter(buttonText, handlers.onSave)
];
const customerWizardSteps = (handlers) => [
    { label: "Stammdaten", rows: [
        { pattern: "grid", columns: "450px", fields: [
            { label: "Name", id: "inputCustomerName", type: "text", attributes: { "data-field": "name" }, required: true },
        ]},
        { pattern: "grid", columns: "220px 220px", fields: [
            { label: "Kurzname", id: "inputCustomerShortName", type: "text", attributes: { "data-field": "shortName" } },
            { label: "Sprache",  id: "inputCustomerLanguage",  onMount: handlers.initLanguageDropdown },
        ]},
    ]},
    { label: "Applikationen", rows: [
        applicationItemManagerRow(handlers.wizardApplications),
    ]},
    { label: "Services", rows: [
        serviceItemManagerRow(handlers.wizardServices),
    ]},
    { label: "Dashboard Module", rows: [
        { pattern: "grid", columns: "450px", fields: [
            { label: "Dashboard Module", id: "inputCustomerDashboardModules", multiple: true, onMount: handlers.initDashboardModulesDropdown },
        ]},
    ]},
    { label: "Erlaubte Sprachen", rows: [
        { pattern: "grid", columns: "450px", fields: [
            { label: "Erlaubte Sprachen", id: "inputCustomerPermittedLanguages", multiple: true, onMount: handlers.initPermittedLanguagesDropdown },
        ]},
    ]},
    { label: "Zusammenfassung", rows: [
        { type: "div", class: "wizardSummaryContainer", attributes: { id: "wizardSummaryContainer" } },
    ]},
];

const userRows = (buttonText, handlers) => [
    { pattern: "grid", columns: "240px 240px", fields: [
        { label: "Email", id: "dropdownEmail", attributes: { "data-field": "email" }, type: "text", required : true },
        { label: "Rolle", id: "dropdownRole",  attributes: { "data-field": "roleId" }, onMount: handlers.initRoleDropdown },
        { label: "Team",  id: "dropdownTeam",  attributes: { "data-field": "teamId" }, onMount: handlers.initTeamDropdown },
        { label: "Beschäftigungsverhältnis", id: "dropdownEmploymentType", attributes: { "data-field": "employmentType" }, onMount: handlers.initEmploymentTypeDropdown }
    ]},
    createSaveFooter(buttonText, handlers.onSave)
];
const teamRows = (buttonText, handlers) => [
    { pattern: "grid", columns: "460px", fields: [
        { label: "Teamname",       id: "inputTeamName", required: true, type: "text", attributes: { "data-field": "name" } },
        { label: "Berechtigungen", id: "dropdownPermission", multiple: true, onMount: handlers.initPermissions },
        { label: "Aktivitäten",    id: "dropdownActivity",   multiple: true, onMount: handlers.initActivities },
    ]},
    createSaveFooter(buttonText, handlers.onSave)
];
const permissionRows = (buttonText, handlers) => [
    { pattern: "verticalGrid", rows: [
        { width: "600px", fields: [
            { label: "Rollenname", id: "inputRoleName", required: true, type: "text", attributes: { "data-field": "name" } },
        ]},
        { width: "600px", fields: [
            { label: "Berechtigungen", id: "dropdownPermission", required: true, multiple: true, onMount: handlers.initPermissions },
        ]},
    ]},
    createSaveFooter(buttonText, handlers.onSave)
];
const applicationRows = (buttonText, handlers) => [
    { pattern: "grid", columns: "500px", fields: [
        { label: "Name",         id: "inputApplicationName",        type: "text", attributes: { "data-field": "name" }, required: true, },
        { label: "Projekte", id: "dropdownProjects", multiple: true, onMount: handlers.initProjectsDropdown },
        { label: "Beschreibung", id: "inputApplicationDescription", type: "textarea", class: "dialogTextarea dialogInput", attributes: { "data-field": "description" } },
    ]},
    createSaveFooter(buttonText, handlers.onSave)
];

const serviceRows = (buttonText, handlers) => [
    { pattern: "grid", columns: "220px 220px", fields: [
        { label: "Name",         id: "inputServiceName",        type: "text", attributes: { "data-field": "name" }, required: true, },
        { label: "Beschreibung", id: "inputServiceDescription", type: "textarea", class: "dialogTextarea dialogInput", attributes: { "data-field": "description" } },
    ]},
    { pattern: "grid", columns: "460px", fields: [
        { label: "URL", id: "inputServiceUrl", type: "text", attributes: { "data-field": "url" }, placeholder: "https://...", required: true },
    ]},
    createSaveFooter(buttonText, handlers.onSave)
];

const createSaveFooter = (text, onClick) => ({ pattern: "footer", buttons: [{ text, class: "bigButton saveButton dialogInput", onclick: onClick }] });
const createDeleteDialog = (title, messages, onDelete, buttonText = "Löschen") => ({
    header: { title },
    content: {
        rows: [
            { pattern: "message", texts: Array.isArray(messages) ? messages : [messages] },
            { pattern: "footer", buttons: [
                { text: buttonText, class: "smallButton deleteButton dialogInput", onclick: onDelete }
            ]}
        ]
    }
});

export function getConfig(dialogName, handlers = {}, isTask = false) {
    switch (dialogName) {
        case "export": {
            const selectedCount = getSelectedExportRowCount(currentTable);
            const exportText = selectedCount > 0
                ? `${selectedCount} ${selectedCount === 1 ? 'Zeile' : 'Zeilen'} als .xlsx exportieren`
                : "Aktuelle Tabelle als .xlsx exportieren";
            const isEntryTable = currentTable?.tableName === "entry";
            return {
                header: { title: "Daten exportieren" },
                content: { rows: [
                    { type: "p", text: exportText, class: "message" },
                    ...(isEntryTable ? [
                        { class: "darkmodeContainer", type: "div", children: [
                            { type: "p", text: "Exportierte Einträge als fakturiert markieren" },
                            { type: "input", id: "checkboxMarkFactored", class: "styledCheckbox", attributes: { type: "checkbox" } },
                        ]}
                    ] : []),
                    { pattern: "footer", buttons: [{ text: "Exportieren", class: "smallButton dialogInput", onclick: handlers.onExport }]}
                ]}
            };
        }
        
        case "editTime": return {
            header: { title: "Zeiteintrag bearbeiten" },
            content: { rows: [
                { pattern: "grid", columns: "220px 220px", fields: [
                    { label: "Start", id: "dropdownStart", type: "timepicker", attributes: { "data-field": "start" }, placeholder: "Start", required: true },
                    { label: "Ende",  id: "dropdownEnd",   type: "timepicker", attributes: { "data-field": "end" }, placeholder: "Ende", onceOptional: true },
                ]},
                createSaveFooter("Bearbeiten", handlers.onSave)
            ]}
        };
        case "deleteTime": return createDeleteDialog("Zeiteintrag löschen?", ["Dieser Zeiteintrag wird dauerhaft gelöscht"], handlers.onDelete);

        case "createTimeLog": return {
            header: { title: "Zeiterfassung erstellen" },
            content: { rows: timeLogRows("Erstellen", handlers, [
                { pattern: "grid", columns: "450px", fields: [
                    { label: "Datum", id: "inputTimeLogDate", type: "datepicker", attributes: { "data-field": "date" }, required: true },
                ]}
            ])}
        };
        case "editTimeLog": return {
            header: { title: `Zeiterfassung bearbeiten${handlers.dateLabel ? `: ${handlers.dateLabel}` : ''}` },
            content: { rows: timeLogRows("Speichern", handlers) }
        };
        case "deleteTimeLog":
            return createDeleteDialog("Zeiterfassung löschen?", ["Diese Zeiterfassung wird dauerhaft gelöscht"], handlers.onDelete);

        case "createEntry": return {
            header: { title: "Leistungsnachweis erstellen" },
            content: { rows: entryRows("Erstellen", handlers, isTask) }
        };
        case "editEntry": return {
            header: { title: "Leistungsnachweis bearbeiten" },
            content: { rows: entryRows("Bearbeiten", handlers) }
        };
        case "deleteEntry":
            return createDeleteDialog("Leistungsnachweis löschen?", ["Dieser Leistungsnachweis wird dauerhaft gelöscht"], handlers.onDelete);

        case "createCustomer": return {
            header: { title: "Kunden hinzufügen" },
            content: { rows: [
                { pattern: "wizard", steps: customerWizardSteps(handlers), onStepClick: handlers.onWizardStepClick },
                { pattern: "footer", buttons: [
                    { id: "wizardBackBtn", text: "Abbrechen", class: "smallButton cancelButton dialogInput", onclick: handlers.onWizardBack },
                    { id: "wizardNextBtn", text: "Weiter",    class: "smallButton saveButton dialogInput",   onclick: handlers.onWizardNext },
                ]},
            ]}
        };
        case "editCustomer": return {
            header: { title: "Kunde bearbeiten" },
            content: { rows: customerRows("Bearbeiten", handlers, false) }
        };
        case "deleteCustomer":
            return createDeleteDialog("Kunde löschen?", ["Dieser Kunde wird dauerhaft gelöscht"], handlers.onDelete);
        case "editCustomerDashboardModules": return {
            header: { title: "Dashboard Module verwalten" },
            content: { rows: [
                { pattern: "grid", columns: "450px", fields: [
                    { label: "Dashboard Module", id: "inputCustomerDashboardModules", multiple: true, onMount: handlers.initDashboardModulesDropdown },
                ]},
                createSaveFooter("Speichern", handlers.onSave)
            ]}
        };
        case "editCustomerPermittedLanguages": return {
            header: { title: "Erlaubte Sprachen verwalten" },
            content: { rows: [
                { pattern: "grid", columns: "450px", fields: [
                    { label: "Erlaubte Sprachen", id: "inputCustomerPermittedLanguages", multiple: true, onMount: handlers.initPermittedLanguagesDropdown },
                ]},
                createSaveFooter("Speichern", handlers.onSave)
            ]}
        };
        case "editCustomerApplications": return {
            header: { title: "Applikationen verwalten" },
            content: { rows: [
                applicationItemManagerRow(handlers),
                createSaveFooter("Speichern", handlers.onSave)
            ]}
        };
        case "editCustomerServices": return {
            header: { title: "Services verwalten" },
            content: { rows: [
                serviceItemManagerRow(handlers, { includeConfigButton: hasPermission("Customers.Update.Service_config") }),
                createSaveFooter("Speichern", handlers.onSave)
            ]}
        };

        case "editServiceConfiguration":
            if (!hasPermission("Customers.Update.Service_config")) return null;
            if (!handlers.initJsonEditor) return null;
            return {
                header: { title: `Konfiguration${handlers.serviceName ? `: ${handlers.serviceName}` : ''}`, back: true },
                content: { rows: [
                    { type: "app-json-editor", id: "inputServiceConfiguration", class: "serviceConfigEditor", onMount: handlers.initJsonEditor },
                    createSaveFooter("Speichern", handlers.onSave)
                ]}
            };

        case "createUser": return {
            header: { title: "Nutzer hinzufügen" },
            content: { rows: userRows("Erstellen", handlers) }
        };
        case "editUser": return {
            header: { title: "Nutzer bearbeiten" },
            content: { rows: userRows("Bearbeiten", handlers) }
        };
        case "deleteUser": 
            return createDeleteDialog("Nutzer entfernen?", ["Dieser Nutzer wird dauerhaft aus dem System entfernt", "Alle Daten des Nutzers werden dauerhaft gelöscht"], handlers.onDelete, "Entfernen");
        
        case "createTeam": return {
            header: { title: "Team erstellen" },
            content: { rows: teamRows("Erstellen", handlers) }
        };
        case "editTeam": return {
            header: { title: "Team bearbeiten" },
            content: { rows: teamRows("Bearbeiten", handlers) }
        };
        case "deleteTeam": 
            return createDeleteDialog("Team löschen", ["Dieses Team wird dauerhaft gelöscht", "Nutzer werden aus dem Team entfernt."], handlers.onDelete);

        case "createRole": return {
            header: { title: "Rolle erstellen" },
            content: { rows: permissionRows("Erstellen", handlers) }
        };
        case "editRole": return {
            header: { title: "Rolle bearbeiten" },
            content: { rows: permissionRows("Bearbeiten", handlers) }
        };
        case "deleteRole":
            return createDeleteDialog("Rolle löschen?", ["Diese Rolle wird dauerhaft gelöscht", "Betroffene Nutzer können auf bestimmte Funktionen", "nicht mehr zugreifen"], handlers.onDelete);

        case "createProject": return {
            header: { title: "Projekt erstellen" },
            content: { rows: [
                { pattern: "grid", columns: "460px", fields: [
                    { label: "Projektname", id: "inputProjectName", type: "text", attributes: { "data-field": "name" }, required: true },
                ]},
                createSaveFooter("Erstellen", handlers.onSave)
            ]}
        };
        case "editProject": return {
            header: { title: "Projekt bearbeiten" },
            content: { rows: [
                { pattern: "grid", columns: "380px 40px", fields: [
                    { label: "Projektname", id: "inputProjectName", type: "text", attributes: { "data-field": "name" }, required: true },
                    { label: "⠀", type: "input", id: "checkboxIsActive", class: "styledCheckbox styledCheckbox-grid dialogInput", attributes: { type: "checkbox", "data-field": "isActive" } },
                ]},
                createSaveFooter("Bearbeiten", handlers.onSave)
            ]}
        };
        case "deleteProject":
            return createDeleteDialog(
                "Projekt löschen?",
                ["Dieses Projekt wird dauerhaft gelöscht.", "Zugehörige Leistungsnachweise werden nicht gelöscht."],
                handlers.onDelete
            );

        case "createApplication": return {
            header: { title: "Applikation erstellen" },
            content: { rows: applicationRows("Erstellen", handlers) }
        };
        case "editApplication": return {
            header: { title: "Applikation bearbeiten" },
            content: { rows: applicationRows("Bearbeiten", handlers) }
        };
        case "deleteApplication":
            return createDeleteDialog(
                "Applikation löschen?",
                ["Diese Applikation wird dauerhaft gelöscht.", "Alle Projektzuweisungen werden entfernt."],
                handlers.onDelete
            );

        case "createService": return {
            header: { title: "Service erstellen" },
            content: { rows: serviceRows("Erstellen", handlers) }
        };
        case "editService": return {
            header: { title: "Service bearbeiten" },
            content: { rows: serviceRows("Bearbeiten", handlers) }
        };
        case "deleteService":
            return createDeleteDialog("Service löschen?", ["Dieser Service wird dauerhaft gelöscht"], handlers.onDelete);

        case "settings": return {
            header: { title: "Einstellungen" },
            content: { rows: [
                { class: "darkmodeContainer", type: "div", children: [
                    { type: "p", text: "Darkmode" },
                    { type: "label", class: "switch", children: [
                        { type: "input", id: "darkModeCheck", attributes: { type: "checkbox" }, onclick: handlers.onTheme },
                        { type: "span", class: "slider" }
                    ]}
                ]}
            ]}
        };
        
        case "user": return {
            header: { title: "Logout?" },
            content: { rows: [
                { type: "p", class: "message", text: ["Du wirst zu Micorsoft weitergeleitet"] },
                { pattern: "footer", buttons: [{ text: "Logout", class: "smallButton deleteButton dialogInput", onclick: handlers.onLogout }]}]}
        };

        case "restartDay": return {
            header: { title: "Arbeitstag fortsetzen?" },
            content: { rows: [
                { pattern: "message", texts: [
                    "Der letzte Arbeitstag wurde bereits beendet.",
                    "Möchtest du diesen fortsetzen oder einen neuen Arbeitstag starten?"
                ]},
                { pattern: "footer", buttons: [
                    { text: "Neuer Arbeitstag", class: "smallButton saveButton dialogInput", onclick: handlers.onNewDay },
                    { text: "Fortsetzen",       class: "smallButton saveButton dialogInput", onclick: handlers.onContinue }
                ]}
            ]}
        };

        default:
            console.error(`Dialog "${dialogName}" existiert nicht`);
            return null;
    }
}